__turbopack_context__.v({
  "helios-button-group": "BF6HuW_helios-button-group",
  "helios-button-group--align-center": "BF6HuW_helios-button-group--align-center",
  "helios-button-group--align-end": "BF6HuW_helios-button-group--align-end",
  "helios-button-group--align-start": "BF6HuW_helios-button-group--align-start",
  "helios-button-group--mobile-stack": "BF6HuW_helios-button-group--mobile-stack",
});
